import {Component} from "../../../gvf/js/component";
import {GvfService} from "../../../gvf/js/gvf-service";
import {UtilsService} from "../../js/utils-service";
import {ObjectService} from "../../js/object-service";
import {FcmService} from "../../js/fcm-service";
import {PulseReceiverService} from "../../js/pulse-receiver-service";
import {GvfUiService} from "../../../gvf/js/gvf-ui-service";

export class BodyComponent extends Component{
    constructor(scope,$root){
        super(scope,$root);
        this.zIndex = 1050;
    }

    ready(){
        if(this.$root.data("popup-message")){
            swal(
                {
                    type: "info",
                    title: "",
                    text: this.$root.data("popup-message")
                }
            );
        }

        this.findMember("logout").click(
            (ev) => {
                ev.preventDefault();
                $(ev.currentTarget).addClass("is-loading");
                GvfService.endpoint(
                    "/cp/cp/logout",
                    {}
                ).then(
                    (response) => {
                        window.location = response.url;
                    }
                ).catch(
                    (response) => {
                        UtilsService.alertEndpointResponse(response);
                    }
                ).finally(
                    () => {
                        $(ev.currentTarget).removeClass("is-loading");
                    }
                );
            }
        );

        this.findMember("copy-link").click(
            (ev) => {
                ev.preventDefault();
                this.copyToClipboard($(ev.currentTarget).data("url")).then(
                    () => {
                        swal({type: "success", title: "", text: GvfService.lang("Enlace copiado"), timer: 1500, showConfirmButton: false});
                    }
                ).catch(
                    () => {
                        UtilsService.alertEndpointResponse(GvfService.lang("No se ha podido copiar el enlace"));
                    }
                );
            }
        );

        //"Impersonar usuario" / "Impersonar cliente" (web user and customer detail pages): data-endpoint and data-params
        GvfUiService.ready(".js-impersonate",($element) => {
            $element.unbind("click").click(
                (ev) => {
                    ev.preventDefault();
                    const $button = $(ev.currentTarget);
                    GvfService.endpoint($button.data("endpoint"),$button.data("params")).then(
                        (resp) => {
                            //The extranet opens from the alert button: a click, so the browser does not block it as a popup
                            swal({
                                type: "success",
                                title: "",
                                //Escaped, with the line breaks (customer name on its own line)
                                text: $("<div>").text(resp.message).html().replace(/\n/g,"<br>"),
                                html: true,
                                showCancelButton: !!resp.url,
                                confirmButtonText: resp.url?GvfService.lang("Abrir la extranet"):"OK",
                                cancelButtonText: GvfService.lang("Cerrar")
                            },(isConfirm) => {
                                if(isConfirm && resp.url){
                                    window.open(resp.url,"_blank");
                                }
                            });
                        }
                    ).catch(UtilsService.alertEndpointResponse);
                }
            );
        });

        //modal links functionality
        GvfUiService.ready("a[href*='#modal-']",($element) => {
            $element.unbind().click(
                (ev) => {
                    ev.preventDefault();
                    ev.stopPropagation();
                    const $link = $(ev.currentTarget);
                    const parts = $link.attr("href").split("#modal-");
                    const params = GvfService.parseUrlParams(parts[0].split("?")[1]);
                    const model = parts[1];
                    const objectService = new ObjectService(model.replace(/-/g,"_"));
                    objectService.openDetailModal({
                        objectId: params.id,
                        editMode: params.edit==1,
                        lang: params.lang,
                        data: $link.data("payload"),
                        saveCallback: () => {
                            $link.trigger("object:updated",{model});
                        },
                        deleteCallback: () => {
                            $link.trigger("object:deleted",{model});
                        },
                        readyCallback: ($detailPage) => {
                            $link.trigger("object:detailReady",{model,$detailPage});
                        }
                    });
                }
            );
        });

        GvfUiService.ready("a[href^='#modallist-']",($element) => {
            $element.parent().click( //bug in textfit library
                (ev) => {
                    ev.preventDefault();
                    ev.stopPropagation();
                    const parts = $element.attr("href").split("#modallist-");
                    UtilsService.createFormModal({
                        formEndpoint: "/cp/stat-report-detail/get-model-ids-detail",
                        formEndpointParams: {ids_value: parts[1]},
                        size: "lg",
                        title: GvfService.lang("Ver detalle")
                    });
                }
            );
        });

        //tooltips functionality
        GvfUiService.ready("[data-toggle=\"tooltip\"]",($element) => {
            $element.tooltip({boundary: "viewport"});
        });

        //Nested modals scroll fix
        $(document).on(
            "hide.bs.modal",
            ".modal",
            () => {
                this.zIndex--;
                if($(".modal:visible").length>0){
                    $(document.body).addClass("modal-open");
                }
                $(".modal-backdrop").css("z-index",this.zIndex-1);
            }
        );
        $(document).on(
            "show.bs.modal",
            ".modal",
            (ev) => {
                this.zIndex++;
                $(ev.target).css("z-index",this.zIndex);
                this.$root.removeClass("minimized-modals");
            }
        );
        $(document).on(
            "shown.bs.modal",
            ".modal",
            (ev) => {
                $(".modal-backdrop").css("z-index",this.zIndex-1);
                const $minimize = $(ev.target).find(".minimize");
                $minimize.unbind().click(
                    () => {
                        this.$root.toggleClass("minimized-modals modal-open");
                        $minimize.blur();
                    }
                );
            }
        );

        if(this.$root.data("firebase-vapid") && this.$root.data("firebase-config")){
            FcmService.init(this.$root.data("firebase-vapid"),this.$root.data("firebase-config"));
        }

        let pulseConfig = this.$root.data("pulse-service-config");
        if(pulseConfig){
            PulseReceiverService.init(pulseConfig);
            let userId = this.$root.data("cp-user-id");
            this.subscribeCpNotificationTopic(userId);
        }
    }

    /**
     * Copies text to the clipboard
     * @param {string} text
     * @returns {Promise}
     */
    copyToClipboard(text){
        if(navigator.clipboard && window.isSecureContext){
            return navigator.clipboard.writeText(text);
        }
        //Without HTTPS the Clipboard API is not available
        return new Promise((resolve,reject) => {
            const $input = $("<textarea readonly>").val(text).css({position: "fixed", opacity: 0}).appendTo("body");
            $input[0].select();
            const copied = document.execCommand("copy");
            $input.remove();
            copied?resolve():reject();
        });
    }

    subscribeCpNotificationTopic(userId){
        if(userId){
            let action = `user/${userId}/update`;
            PulseReceiverService.onTopic("cpNotification",action,(data) => {
                const badge = document.getElementById("alerts-badge");
                if (badge) {
                    const current = Number(badge.textContent || 0);
                    const unreadData = data.unread;
                    if(unreadData.unread){
                        badge.textContent = unreadData.unread;
                    }else{
                        badge.textContent = current + 1;
                    }

                }
            });
        }
    }
}
